import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import { DragSource, DropTarget } from 'react-dnd'
import classnames from 'classnames'
import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import ImmutableProptypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import Dropdown from 'rc-dropdown'
import Menu, { Item as MenuItem, Divider } from 'rc-menu'
import 'rc-dropdown/assets/index.css'

import Icon from '_components/icon'

import styles from './styles.css'

momentDurationFormatSetup(Moment)

const mapStateToProps = ({ counter, currentTask, settings }) => ({
  counter,
  currentTask,
  settings,
})

class Card extends PureComponent {
  static propTypes = {
    startedAt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    logId: PropTypes.string,
    status: PropTypes.number.isRequired,
    todayItemId: PropTypes.string,
    createTomorrowItemCard: PropTypes.func.isRequired,
    checkReconcileCard: PropTypes.func.isRequired,
    deleteCard: PropTypes.func.isRequired,
    playCard: PropTypes.func.isRequired,
    createCalendarCard: PropTypes.func.isRequired,
    createTodayItemCard: PropTypes.func.isRequired,
  }

  static defaultProps = {
    logId: null,
    todayItemId: null,
  }

  onDeleteClick = () => {
    const { deleteCard, logId, todayItemId } = this.props
    deleteCard(logId, todayItemId)
  }

  onPlayClick = () => {
    const { playCard, name, logId } = this.props
    playCard(name, logId)
  }

  onCheckboxClick = () => {
    const { checkReconcileCard, logId, todayItemId, startedAt, name, status } = this.props
    checkReconcileCard(logId, todayItemId, startedAt, name, status)
  }

  onCreateTomorrowItemClick = sectionId => {
    const { createTomorrowItemCard, name, todayItemId, logId } = this.props
    createTomorrowItemCard(name, sectionId, todayItemId, logId)
  }

  onCreateCalendarClick = () => {
    const { createCalendarCard, name } = this.props
    createCalendarCard({ name })
  }

  onCreateTodayClick = () => {
    const { createTodayItemCard, todayItemId, logId, name } = this.props
    createTodayItemCard(logId, todayItemId, name)
  }

  handleClick = ({ key }) => {
    switch (key) {
      case '1':
        this.onDeleteClick()
        break
      case '2':
        this.onCreateTomorrowItemClick(100)
        break
      case '3':
        this.onCreateTomorrowItemClick(200)
        break
      case '4':
        this.onCreateTomorrowItemClick(300)
        break
      case '5':
        this.onCreateTomorrowItemClick(400)
        break
      case '6':
        this.onCreateCalendarClick()
        break
      default:
    }
    return null
  }

  menu = () => (
    <Menu onClick={this.handleClick} selectable={false}>
      <MenuItem key="1">Delete</MenuItem>
      <MenuItem key="2">
        Move to {this.props.settings.get('tomorrowSection1') || 'Tomorrow'}
      </MenuItem>
      <MenuItem key="3">Move to {this.props.settings.get('tomorrowSection2') || 'Later'}</MenuItem>
      <MenuItem key="4">
        Move to {this.props.settings.get('tomorrowSection3') || 'Much Later'}
      </MenuItem>
      <MenuItem key="5">Move to {this.props.settings.get('tomorrowSection4') || 'Never'}</MenuItem>
      <MenuItem key="6">Add to Calendar</MenuItem>
    </Menu>
  )

  renderStatus = () => {
    const { status } = this.props
    let iconName = ''

    switch (status) {
      case 0:
        iconName = 'hmm-icon-square-empty'
        break
      case 1:
        iconName = 'hmm-icon-square-partial'
        break
      case 2:
        iconName = 'hmm-icon-square-check'
        break
      case 3:
        iconName = 'hmm-icon-square-partial'
        break
      case 4:
        iconName = 'hmm-icon-continue'
        break
      default:
        iconName = 'hmm-icon-square-empty'
    }

    return <i onClick={this.onCheckboxClick} className={classnames(`${iconName}`, styles.icon)} />
  }

  render() {
    const { name, logId, todayItemId, startedAt } = this.props
    const borderColor = todayItemId ? 'rgba(106,132,205, 0.8)' : 'rgba(150,150,150,0.8)'

    return (
      <div className={classnames(styles.card)} style={{ border: `${borderColor} 3px solid` }}>
        {this.renderStatus()}
        <div className={classnames(styles.name)}>{name}</div>
        {Moment(startedAt).format('MMDDYYYY') === Moment().format('MMDDYYYY') ? (
          <i onClick={this.onPlayClick} className={classnames('hmm-icon-play', styles.icon)} />
        ):(
          <i onClick={this.onCreateTodayClick} className={classnames('fa fa-arrow-up', styles.icon)} />
        )}
        <Dropdown trigger={['click']} overlay={this.menu()} animation="slide-up">
          <i className={classnames('fa fa-ellipsis-v', styles.icon)} />
        </Dropdown>
      </div>
    )
  }
}

export default connectRedux(mapStateToProps, null)(Card)



// WEBPACK FOOTER //
// ./src/views/reconcile/card/index.js